import { Box } from '@mui/material';
import theme from '@/theme';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {
  ENVIRONMENT_NAMES,
  getCurrentEnvironment,
  isProductionEnvironment,
} from '@/utils/environmentIdentification';

export default function EnvHeader() {
  // Don't show header in production
  if (isProductionEnvironment()) return null;

  const headerHeight = 20;
  const currentEnv = getCurrentEnvironment();

  const envLabel =
    currentEnv === ENVIRONMENT_NAMES.DEVELOPMENT
      ? 'Development Version'
      : currentEnv === ENVIRONMENT_NAMES.STAGING
        ? 'Staging Version'
        : '';

  return (
    <>
      <Box
        sx={{
          height: headerHeight,
          bgcolor: theme.palette.warning.main,
          zIndex: 9999,
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          fontSize: 12,
          display: 'flex',
          alignItems: 'center',
          px: 1,
        }}
      >
        <WarningAmberIcon fontSize="small" />
        <strong style={{ marginLeft: 4, paddingTop: 1 }}>
          {envLabel} {__APP_VERSION__}-{__COMMIT_HASH__}-{__BRANCH_NAME__} (Last
          Built: {__LAST_BUILD_DATE__})
        </strong>
      </Box>
      {/* Spacer to offset the fixed header */}
      <Box sx={{ height: headerHeight }} />
    </>
  );
}
